export interface MpBrickController {
  unmount?: () => Promise<void> | void;
}

export function unmountBrickSafely(controller: MpBrickController | null | undefined): void {
  if (!controller || typeof controller.unmount !== "function") return;
  try {
    const result = controller.unmount();
    if (result && typeof (result as Promise<void>).then === "function") {
      (result as Promise<void>).then(undefined, () => {});
    }
  } catch {
    return;
  }
}
